import { useNavigate, useParams } from "react-router-dom";
import patient from "../../assets/img/patient.jpg";
import React, { useEffect, useState, useRef } from "react";
import { textRetriever } from "../../util/custom";
import { CallWithAuth } from "../../action/apiActions";
import { GET_PATIENT_RELATIVES_API_URL } from "../../action/apiPath";
import { convertWebmToMp3 } from "../../components/audioConverter/mp3Converter";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import mutemic from '../../assets/img/unmute-mic.svg';
import { WHISPER_LIVE_TRANSCRIPTION, WHISPER_LIVE_TRANSCRIPTION_SUBMIT } from "../../action/apiPath";
import { toast } from "react-toastify";
import { MdEmail } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";


const RecordingInformationPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();


  const [getRelativesDataDeatil, setRelativesDataDeatil] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [sessionId, setSessionId] = useState(null); // ← for session tracking
  const [transcribedText, setTranscribedText] = useState(""); // ← for merging text
  const [loadingTranscription, setLoadingTranscription] = useState(false);


  const recordedChunksRef = useRef([]);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [mp3URL, setMp3URL] = useState(null);
  const streamRef = useRef(null);
  const audioRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [audioTypeError, setAudioTypeError] = useState(""); // ✅ ADDED: validation error state
  const [audioType, setAudioType] = useState("");


  useEffect(() => {
    if (id == undefined || id == "") {
      navigate("/");
      return;
    }
    getReleatives();
  }, [id]);

  useEffect(() => {
    if (!isLoading) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }, [isLoading]);


  const getReleatives = async () => {
    try {
      /**
       * The API endpoint to fetch the relatives data
       * @type {string}
       */
      const url = `${GET_PATIENT_RELATIVES_API_URL}/${id}/?extra=true`;

      const response = await CallWithAuth("GET", url);

      if (response.res.data && response.res.data.statusCode === 200) {
        setRelativesDataDeatil(response.res.data.data);
      }
      setIsLoading(false);
    } catch (error) { }
  };
  // Recording start section

  const startRecording = async () => {
    if (mediaRecorder && mediaRecorder.state === "paused") {
      mediaRecorder.resume();
      setIsPaused(false);
      return;
    }

    // if (mediaRecorder)  return;

    resetRecording();

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    const recorder = new MediaRecorder(stream);
    setMediaRecorder(recorder);
    setAudioChunks([]);
    setIsRecording(true);
    setIsPaused(false);

    // console.log(isRecording, "===", isPaused)

    recorder.ondataavailable = e => {
      if (e.data.size > 0) {
        setAudioChunks(prev => [...prev, e.data]);
        recordedChunksRef.current.push(e.data); // ✅ persist across resumes
      }
    };

    recorder.start(1000);
  };

  // Recoding pause section
  const pauseRecording = async () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();
      setIsRecording(false);
      setIsPaused(true);

      mediaRecorder.onstop = async () => {
        try {
          const blob = new Blob(audioChunks, { type: "audio/webm" });
          const url = URL.createObjectURL(blob);
          setAudioURL(url);

          // Convert to MP3
          setLoadingTranscription(true); // ⬅️ START LOADING
          const mp3Blob = await convertWebmToMp3(blob);
          const mp3ObjectUrl = URL.createObjectURL(mp3Blob);
          setMp3URL(mp3ObjectUrl);

          setTimeout(() => {
            if (audioRef.current) {
              audioRef.current.load();
            }
          }, 100);

          // Upload to backend
          const formData = new FormData();
          formData.append("audio", mp3Blob, "chunk.mp3");
          formData.append("patient_id", id);
          // formData.append("session_type", audioType || "clinical_interview");
          formData.append("is_chunk", "true");

          if (sessionId) {
            formData.append("session_id", sessionId); // ⬅️ Include only if available
          }

          const response = await CallWithAuth("POST", WHISPER_LIVE_TRANSCRIPTION, formData);
          if (response?.res?.data?.data) {
            const resultText = response.res.data.data?.transcription || "";
            const returnedSessionId = response?.res?.data?.data?.session_id;
            if (returnedSessionId && !sessionId) {
              setSessionId(returnedSessionId); // First time only
            }
            // setTranscribedText(response.res.data.data?.transcription); // ✅ UPDATE TEXTAREA

            if (resultText) {
              setTranscribedText(prev => prev ? `${prev}\n${resultText}` : resultText); // Merge
            }
          }

        } catch (err) {
          console.error("Transcription error:", err);
        } finally {
          setLoadingTranscription(false); // ⬅️ STOP LOADING
        }
      };
    }
  };


  // reset recording section 

  const resetRecording = (shouldClearText = false) => {
    // ✅ ADDED: Clean up object URLs
    if (audioURL) URL.revokeObjectURL(audioURL);
    if (mp3URL) URL.revokeObjectURL(mp3URL);

    setAudioURL(null);
    setMp3URL(null); // ✅ ADDED
    setAudioChunks([]);
    setMediaRecorder(null);
    setIsRecording(false);
    setIsPaused(false);

    if (shouldClearText) {
      setTranscribedText(''); // ✅ Clear only if asked
    }

    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  };

  // ✅ ADDED: Submit handler
  const handleSubmitRecording = async () => {
    setIsSubmitting(true)
    if (!audioURL) return;

    // const blob = new Blob(audioChunks, { type: "audio/webm" });
    // const formData = new FormData();
    // formData.append("file", blob, "recording.webm");
    // formData.append("patientId", id); // Optional: if backend needs it


    const payload = {
      "session_id": sessionId,
      "final_transcription": transcribedText,
      "generate_speech": true,
      "voice": "nova",
      "session_type": audioType
    }


    try {
      const response = await CallWithAuth("POST", WHISPER_LIVE_TRANSCRIPTION_SUBMIT, payload); // Replace with your actual endpoint
      // console.log("Transcription Result:", response.res.data.message);
      if (response?.res?.data?.message) {
        setIsSubmitting(false);
        resetRecording(true);
        setAudioType("");
        setTranscribedText("");
        // You can update UI here or show a success toast
        toast.success(response.res.data.message, {
          autoClose: 2000,
          position: "top-right",
        });
        setTimeout(() => {
          window.location.reload()
        }, 500);
      }
    } catch (error) {
      console.error("Error submitting recording:", error);
      setIsSubmitting(false);
    }
  };

  const downloadFullRecording = async () => {
    if (recordedChunksRef.current.length === 0) {
      toast.error("No recording available to download.");
      return;
    }

    const fullBlob = new Blob(recordedChunksRef.current, { type: "audio/webm" });

    try {
      const mp3Blob = await convertWebmToMp3(fullBlob);
      const mp3ObjectUrl = URL.createObjectURL(mp3Blob);

      const link = document.createElement("a");
      link.href = mp3ObjectUrl;
      link.download = `full_recording_${Date.now()}.mp3`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(mp3ObjectUrl); // optional cleanup
    } catch (err) {
      console.error("Error converting or downloading MP3:", err);
      toast.error("Failed to download MP3.");
    }
  };



  return (
    <div className="front-end-dashboard">
      {isLoading && (
        <div className="full-page-loader">
          <div className="loader"></div>
        </div>
      )}
      <>
        <div className="site_container">
          <div className="dashboard-page-header">
            <div className="left-div">
              <h3>Recording Information</h3>
              <p>E-Mail Send to Patient's</p>
            </div>
          </div>
          <div className="dashboard-page-body">
            <div className="dashboard-common-details-wrapper">


              <div className="custom-white-card">
                <ul className="ciw-content-list-s1">
                  <li>
                    <div className="icon-container"><MdEmail /></div>
                    <div className="text-container">
                      <label htmlFor="">Patient Email:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.email)}</div>
                    </div>
                  </li>
                  <li>
                    <div className="icon-container"><FaRegUser /></div>
                    <div className="text-container">
                      <label htmlFor="">Patient Name:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.full_name)}</div>
                    </div>
                  </li>
                </ul>
              </div>


              <div className="w-full">
                <div className="custom-white-card">
                  <div className="ciw-bottom-se-headerpart mb-4">
                    <div className="lebox">
                      <h4>Information</h4>
                    </div>
                  </div>

                  <textarea
                    className="form-control"
                    rows={10}
                    cols={10}
                    value={loadingTranscription ? "Transcribing, please wait..." : transcribedText}
                    onChange={(e) => setTranscribedText(e.target.value)} // Optional: allow editing
                  />
                </div>
              </div>
            </div>
          </div>

          {/* when Api call  */}
          {loadingTranscription && (
            <div className="c-loader">
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          )}


          {/* when start or resume record */}
          {isRecording && !isPaused && (
            <div className="">
              <img
                src={mutemic}
                alt="Recording..."
                style={{ width: "60px", animation: "pulse 1.5s infinite ease-in-out" }}
              />
              <p style={{ margin: "-6px 0 0 0", fontSize: "14px", fontWeight: 600 }}>Listening...</p>
            </div>
          )}
          {mp3URL && (
            <>
              {/* ✅ ADDED: Error message directly below dropdown, without shifting */}
              {audioTypeError && (
                <div
                  className="text-danger fw-semibold"
                  style={{
                    fontSize: "0.875rem",
                    whiteSpace: "nowrap"
                  }}
                >
                  {audioTypeError}
                </div>
              )}
              <div className="form-group-submit-action-common end">

              </div>
            </>
          )}

          <div className="recoding-information-action-but-groups">
            <div className="left-actions">
              {/* 1st time show start btn afer record statrt it will be hide */}
              {!isRecording && !isPaused && (
                <button
                  onClick={startRecording}
                  className="btn btn-primary px-4 py-2 fw-bold rounded-3"
                >
                  Start Recording
                </button>
              )}
              {/* if start or resume recoding click*/}
              {isRecording && !isPaused && (
                <button
                  onClick={pauseRecording}
                  className="btn btn-warning px-4 py-2 fw-bold rounded-3"
                  disabled={loadingTranscription} // optional to prevent double-click
                >
                  Pause Recording
                </button>
              )}
              {/* after pause btn clicked */}
              {isPaused && (
                <button
                  onClick={startRecording}
                  className="btn btn-success px-4 py-2 fw-bold rounded-3"
                >
                  Resume Recording
                </button>
              )}

              {audioURL && (
                <>
                  {/* <audio
                        ref={audioRef}
                        src={audioURL}
                        controls
                        preload="auto"
                        controlsList="nodownload"
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          borderRadius: "12px",
                          background: "#f8f9fa",
                          padding: "0.4rem"
                        }}
                      /> */}
                  <button
                    onClick={() => resetRecording(true)}
                    className="btn btn-light px-3 py-2 fw-bold border rounded-3"
                  >
                    Reset
                  </button>
                </>
              )}

              {mp3URL && (
                <>
                  {/* <div className="position-relative">  */}
                  {/* ✅ ADDED container for row + absolute error */}
                  {/* <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 mt-4"> */}
                  <button
                    onClick={downloadFullRecording}
                    className="btn btn-secondary px-4 py-2 fw-bold rounded-3"
                  >
                    Download MP3
                  </button>
                  {/* ✅ CHANGED: Wrap select in relative container */}
                  <div className="filter-input">
                    <select
                      className={`form-select ${audioTypeError ? "is-invalid" : ""}`}
                      style={{ height: "41px" }}
                      value={audioType}
                      onChange={(e) => {
                        setAudioType(e.target.value);
                        if (e.target.value !== "") {
                          setAudioTypeError("");
                        }
                      }}
                    >
                      <option value="">Select Session Type</option>
                      <option value="clinical_interview">Clinical Interview</option>
                      <option value="formulation">Formulation</option>
                      <option value="mse">MSE</option>
                      <option value="background_info_audio">Background Info</option>
                    </select>
                  </div>
                </>
              )}
            </div>
            <div className="right-actions">
              <button
                className="btn btn-primary px-4 py-2 fw-bold rounded-3"
                onClick={() => {
                  if (audioType === "") { // ✅ VALIDATION
                    setAudioTypeError("Please select a valid session type.");
                    return;
                  }
                  setAudioTypeError(""); // ✅ clear error
                  handleSubmitRecording(); // ✅ Call the function here
                }}
              >
                {isSubmitting ? (
                  <>
                    Submit <LoaderIndex />
                  </>
                ) : (
                  <>
                    Submit <span className="ms-2">&rarr;</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default RecordingInformationPage;
